<template>
  <div>
    <loader :loading="loading"></loader>
    <div v-if="userLoggedIn" class="loggedinbar">
      {{ userName }} <a href="#" @click.prevent="logoutUser()">Logout</a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { UserData } from "@/api/UserData";
import Loader from "@/components/MainLoader.vue";
import { ref, computed, Ref, ComputedRef, onBeforeMount } from "vue";
import { useUserStore } from "@/stores/root/users";
import { storeToRefs } from "pinia";
import { useQuoteStore } from "@/stores/root/quote";
import { checkUserStatus } from "@/utils/Utils";

const userStore = storeToRefs(useUserStore());
const loading: Ref<boolean> = ref(false);
const user = userStore.user;
const quote = useQuoteStore();
const userLoggedIn: ComputedRef<boolean> = computed(() => {
  return user.value.loggedIn;
});

// onBeforeMount(() => {
//   checkUserStatus();
// });

const userName: ComputedRef<string> = computed(() => {
  return (
    user.value.firstName[0].toUpperCase() +
    user.value.firstName.slice(1) +
    " " +
    user.value.lastName[0].toUpperCase() +
    user.value.lastName.slice(1)
  );
});

const logoutUser = async () => {
  loading.value = true;
  const result = await UserData.logout();
  loading.value = false;
  if (result.error) {
    console.log("User logout error: %o", result.message);
  } else {
    user.value.email = "";
    user.value.firstName = "";
    user.value.lastName = "";
    user.value.entityId = 0;
    user.value.loggedIn = false;
    //userStore.logout;
  }
};
</script>
